import { render, staticRenderFns } from "./SearchArticle.vue?vue&type=template&id=b483d164&scoped=true"
import script from "./SearchArticle.vue?vue&type=script&lang=js"
export * from "./SearchArticle.vue?vue&type=script&lang=js"
import style0 from "./SearchArticle.vue?vue&type=style&index=0&id=b483d164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b483d164",
  null
  
)

export default component.exports